import { faFileImport } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import {Table } from 'react-bootstrap';
//Redux
const ResultadosFiltro = ({resultados,configuracion}) => {

 return (
 
    <div className="box">
     <div className="box-header with-border">
                  <h5
                      style={{ color: "#434343" }}
                    >
                    <FontAwesomeIcon icon={faFileImport} /> Resultados
                  </h5>
                
                </div>
      <div className="row p-2">
        <div className="col-12 mb-2">
         <p>Campaña: {resultados.campaign} </p>
         <br/>
         <Table striped bordered hover style={{textAlign:'center'}}>
            <thead>
                <tr>
                <th>Estado</th>
                <th>Cantidad de Webinars</th>
                <th>% Asistencia</th>
                <th>% Inscritos</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                  <td>{resultados.bandera.includes('ROJO') ? <span className='badge badge-danger'> <i className='fa fa-arrow-down'></i> </span> : <span className='badge badge-success'> <i className='fa fa-arrow-up'></i> </span>}</td>
                  <td>{resultados.total_webinars}</td>
                  <td>{resultados.p_asistencia}%</td>
                  <td>{resultados.p_inscritos}%</td>
              
                </tr>
               
            </tbody>
            </Table>
         
        </div>     
      </div>
    </div>
  
  
    );
};

export default ResultadosFiltro;
